export type AiPromptCategory = 'resume' | 'jobs' | 'community' | 'general';
export type AiPromptStatus = 'active' | 'planned';

export interface AiPromptVariable {
  name: string;
  description: string;
  required?: boolean;
}

export interface AiPromptDefinition {
  id: string;
  label: string;
  description: string;
  category: AiPromptCategory;
  enabled: boolean;
  isBuiltIn: boolean;
  status: AiPromptStatus;
  modelId: string;
  temperature: number;
  maxTokens: number;
  promptTemplate: string;
  requiredVariables?: string[];
  variables: AiPromptVariable[];
  updatedAt?: string;
}

export const CATEGORY_LABELS: Record<AiPromptCategory, string> = {
  resume: 'Resume',
  jobs: 'Job ingestion',
  community: 'Community',
  general: 'General',
};

export const PROMPT_IDS = {
  RESUME_ANALYSIS: 'resume_analysis',
  JOB_EXTRACTION_DISCORD: 'job_extraction_discord',
  JOB_EXTRACTION_TELEGRAM: 'job_extraction_telegram',
} as const;
